// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home 컴포넌트는 이제 라우팅 역할만 담당 */
/* 실제 레이아웃은 각 하위 컴포넌트에서 관리 */


`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B,4BAA4B","sourcesContent":["/* Home 컴포넌트는 이제 라우팅 역할만 담당 */\n/* 실제 레이아웃은 각 하위 컴포넌트에서 관리 */\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
